<template>
  <AppSnackbar />
  <AppConfirmDialog />
  <AppLoading />
  <RouterView />
</template>

<script setup lang="ts">
import { useCrisp } from './composables/useCrisp'
import { useAppTheme } from './composables/ui/useAppTheme'
import AppLoading from './components/AppLoading.vue'
import AppSnackbar from './components/AppSnackbar.vue'
import AppConfirmDialog from './components/AppConfirmDialog.vue'
import { useDropshipAutoSync } from './composables/useDropshipAutoSync'
import { THEME_STORAGE_KEY, LEGACY_THEME_KEY } from './plugins/vuetify'

useCrisp()
useDropshipAutoSync()

const { applyPreset } = useAppTheme()
const savedTheme = localStorage.getItem(THEME_STORAGE_KEY) ?? localStorage.getItem(LEGACY_THEME_KEY)
if (savedTheme && (savedTheme === 'light' || savedTheme === 'dark')) {
  applyPreset(savedTheme)
}
</script>

<style lang="scss">
#app {
  font-family: 'Inter', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-width: 0;
  max-width: 100%;
}

html {
  overflow-x: clip;
}

body {
  margin: 0;
  min-width: 0;
  max-width: 100%;
  overflow-x: clip;
}
</style>
